
import { Vue, Component, Prop } from 'vue-property-decorator';
import { PackageItem } from '@/features/shipment/types';
import PackageSummaryQueryString from '@/features/shipment/components/createShipment/packageSummary/PackageSummaryQueryString.vue';
import PackageSummaryShipment from '@/features/shipment/components/createShipment/packageSummary/PackageSummaryShipment.vue';

@Component({
  components: {
    PackageSummaryQueryString,
    PackageSummaryShipment,
  },
})
export default class PackageSummary extends Vue {
  @Prop({ required: true }) packages!: PackageItem[];

  @Prop({ default: false }) isQueryStringDebug!: boolean;
}
